import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TaskIdentityInterface } from '@vendasta/task';
import { Status } from '@vendasta/task-manager';
import { MILESTONE_COMPLETED } from '../shared/constants';
import { AskQuestionInfo, NonClickableSection, Subtask } from '../shared/interfaces';

@Component({
  selector: 'project-tracker-simple',
  templateUrl: './simple-project-tracker.component.html',
  styleUrls: ['./simple-project-tracker.component.scss'],
  standalone: false,
})
export class SimpleProjectTrackerComponent implements OnInit {
  @Input() projectTitle;
  @Input() projectIdentity: TaskIdentityInterface;
  @Input() projectUrl: string;

  #projectStatus: string;
  get projectStatus(): string {
    return this.#projectStatus;
  }

  @Input() set projectStatus(projectStatus: string | Status) {
    this.#projectStatus = projectStatus;
    this.badgeColor = this.badgeColorMap.get(projectStatus) || 'blue';
  }

  @Input() subtasks: Subtask[] = [];
  @Input() matElevationClass = 'mat-elevation-z0';
  @Input() hideAskQuestion = false;
  @Output() trackerOpened: EventEmitter<void> = new EventEmitter<void>();
  @Output() trackerClosed: EventEmitter<void> = new EventEmitter<void>();
  @Output() approveClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() provideFeedbackClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() sendFeedbackClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() nonClickableClicked: EventEmitter<NonClickableSection> = new EventEmitter<NonClickableSection>();
  @Output() askQuestionClicked: EventEmitter<AskQuestionInfo> = new EventEmitter<AskQuestionInfo>();
  projectProgress: string;
  badgeColor: string;
  badgeColorMap: Map<string | Status, string> = new Map([
    [Status.Open, 'blue'],
    [Status.InProgress, 'yellow'],
    [Status.WaitingOnCustomer, 'red'],
    [Status.Completed, 'green'],
  ]);

  ngOnInit(): void {
    const completed: number = this.subtasks?.filter((subtask) => subtask.status === MILESTONE_COMPLETED)?.length || 0;
    const total: number = this.subtasks?.length || 0;
    this.projectProgress = `${completed}/${total}`;
  }

  handleAskQuestionClicked(): void {
    this.askQuestionClicked.emit({
      projectIdentity: this.projectIdentity,
      subtasks: this.subtasks,
    });
  }

  handleOpened(): void {
    this.trackerOpened.emit();
  }

  handleClosed(): void {
    this.trackerClosed.emit();
  }

  handleApproveClicked(): void {
    this.approveClicked.emit();
  }

  handleProvideFeedbackClicked(): void {
    this.provideFeedbackClicked.emit();
  }

  handleSendFeedbackClicked(): void {
    this.sendFeedbackClicked.emit();
  }

  handleNonClickableClicked(event: NonClickableSection): void {
    this.nonClickableClicked.emit(event);
  }
}
